function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM10.5 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM10.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM4.5 18a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM10.5 18a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 18a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
});

function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgCategories;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/categories.svg
// module id = 1275
// module chunks = 10